export const queryKeys = {
  STICKY_BTN_DETAIL: 'sticky-btn-detail',
  CONVERSATION_HISTORY_KEY: 'history',
  SEND_CONVERSATION_KEY: 'sendConversation',
  CREATE_LEAD_KEY: 'createLead',
};
